import { Eye, ShieldCheck, Siren, TriangleAlert } from "lucide-react";

/**
 * Shared constants for the public landing page.
 *
 * Kept in one file so the things most likely to change (the contact address,
 * the zone palette) are single-line edits rather than a hunt through sections.
 */

/**
 * TODO(founder): confirm the real inbound address before launch. Derived from
 * the verified production domain (qoldau.live) using the conventional alias —
 * it has NOT been verified as a live mailbox. This is the only place the
 * address appears; the footer, the form and the fallback link all read it.
 */
export const CONTACT_EMAIL = "info@qoldau.live";

export const BRAND = "Qoldau";

/**
 * The four risk zones, in escalation order.
 *
 * `bg` maps to the app's own tokens so the landing matches what a buyer sees in
 * a demo (`success`, `error` and the `*-landing` yellow/orange from
 * tailwind.config.js). Labels are NOT defined here — they come from the
 * existing `zones.*_zone` i18n keys, the only 4-zone set already translated in
 * all three locales.
 *
 * Every zone renders as fill + text label + icon; colour is never the only
 * carrier of meaning. Text on all four fills is `#121233` (black-landing),
 * which is the contrast-verified pairing: 9.5:1 green, 13.8:1 yellow, 6.1:1
 * orange, 4.7:1 red. White on red would be 3.9:1 and fail AA, so all four use
 * dark text.
 */
export const ZONES = [
  { code: "green_zone", bg: "bg-success", Icon: ShieldCheck, meaning: "green_meaning" },
  { code: "yellow_zone", bg: "bg-yellow-landing", Icon: Eye, meaning: "yellow_meaning" },
  { code: "orange_zone", bg: "bg-orange-landing", Icon: TriangleAlert, meaning: "orange_meaning" },
  { code: "red_zone", bg: "bg-error", Icon: Siren, meaning: "red_meaning" },
];

/** Anchor ids, referenced by both the header nav and the sections themselves. */
export const SECTION_IDS = {
  features: "features",
  how: "how-it-works",
  results: "results",
  audiences: "audiences",
  contact: "contact",
};
